import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as attribute from './attribute'
import * as entity from './entity'
import * as snapshot from './snapshot'

export const DOC = gql`
  ${attribute.DOC}
  ${entity.DOC}
  fragment FragmentDmsDimension on DmsDimension {
    id
    name
    description
    note
    terms {
      id
    }
    attributes {
      ...FragmentDmsAttribute
    }
    entities {
      ...FragmentDmsEntity
    }
    snapshots {
      ...FragmentDmsSnapshot
    }
  }
`

/**
 * Transformer for the {@link graphql.schema.FragmentDmsDimensionFragment} to the
 * {@link ents.core.dms.models.Dimension}.
 */
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsDimensionFragment,
  ents.core.dms.models.Dimension
>({
  attributes: graphql.transformers.OUT.list(attribute.TRANSFORMER, {
    onNullish: 'remove',
  }),
  description: transformers.PASS_THROUGH,
  entities: graphql.transformers.OUT.list(entity.TRANSFORMER, {
    onNullish: 'remove',
  }),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Dimension.Id.isId,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  note: transformers.PASS_THROUGH,
  snapshots: graphql.transformers.OUT.list(snapshot.TRANSFORMER, {
    onNullish: 'remove',
  }),
  // TODO: finish implementing
  terms: () => [],
})
